import KeepaLayout from "components/Layout";
import MuiButton from "components/Button";
import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { useOnlineStatus } from "Hook/General/useOnlineStatus";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
	root: {
		background: '#FFF',
	},
	img: {
		objectFit: 'cover',
		width: '100%',
		height: '580px',
		position: 'relative',
		top: '-60px',
		[theme.breakpoints.between('xs', 'sm')]: {
			top: '-90px',
		},
	},
	description: {
		marginTop: '-50px',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '0 16px',
		[theme.breakpoints.between('xs', 'sm')]: {
			marginTop: '-120px',
		},
	},
	title: {
		fontWeight: 700,
		fontSize: '18px',
		color: '#101740',
	},
	subtitle: {
		color: '#888BA0',
		fontSize: '16px',
		fontWeight: 500,
		marginTop: '8px',
	},
}));

const Offline = () => {
	const classes = useStyles();
	const isOnlineMode = useOnlineStatus();
	const [isLoading, setIsLoading] = React.useState(false);

	const handleRetry = () => {
		setIsLoading(true);

		setTimeout(() => {
			if (isOnlineMode) {
				return window.location.reload();
			} else {
				toast.error('لطفا دوباره امتحان کنید', {
					className: 'Toastify-error',
					autoClose: 1000,
					icon: <i style={{ color: '#fff !important', fontSize: 18 }} className="icon-error" />,
				});
			}

			setIsLoading(false);
		}, 600);
	};

	return (
		<KeepaLayout
			noPadding
			buttonComponent={
				<MuiButton isLoading={isLoading} onClick={handleRetry}>
					تلاش مجدد
				</MuiButton>
			}
		>
			<Grid container className={classes.root}>
				<Grid xs={12} item>
					<svg className={classes.img} viewBox="0 0 350 430" fill="none" xmlns="http://www.w3.org/2000/svg">
						<ellipse
							cx="117.047"
							cy="116.932"
							rx="117.047"
							ry="116.932"
							transform="matrix(1 0 0 -1 63.1863 356.956)"
							fill="#F8FAFC"
						/>
						<path
							d="M183.578 180.126V100.996C183.578 94.4179 180.963 88.1093 176.307 83.4578C171.651 78.8064 165.336 76.1933 158.751 76.1933H38.8339C33.9385 76.1933 29.2436 74.2505 25.782 70.7924C22.3205 67.3342 20.3758 62.6439 20.3758 57.7533V6.71049C20.3758 6.29245 20.5602 1.63353 20.4001 1.2473C20.2399 0.861084 19.7124 0.560287 19.4165 0.264679C19.1206 -0.0309143 18.8207 0.424667 18.4341 0.264679C18.0475 0.104706 17.8677 0.264679 17.4493 0.264679C16.6057 0.265198 15.0964 -0.331039 14.4997 0.264679C13.903 0.860413 14.0078 5.86194 14.0067 6.70468V57.7475C14.0067 64.3256 16.6224 70.6343 21.2784 75.2857C25.9344 79.9371 32.2493 82.5502 38.8339 82.5502H158.747C163.643 82.5502 168.338 84.493 171.799 87.9511C175.261 91.4093 177.205 96.0996 177.205 100.99V180.125L183.578 180.126Z"
							fill="#2C447D"
						/>
						<path
							d="M190.739 163.051V150.368C190.739 149.648 190.597 148.935 190.321 148.27C190.045 147.604 189.641 147 189.131 146.491C188.622 145.982 188.016 145.578 187.35 145.303C186.684 145.027 185.971 144.886 185.25 144.886H175.52C174.727 144.885 173.942 145.057 173.221 145.39C172.501 145.722 171.861 146.207 171.347 146.812C170.499 147.802 170.033 149.063 170.035 150.366V163.049L190.739 163.051Z"
							fill="#2C3872"
						/>
						<path
							d="M201.556 192.61V167.27C201.556 166.34 201.373 165.419 201.016 164.559C200.659 163.7 200.137 162.919 199.478 162.262C198.82 161.604 198.038 161.082 197.178 160.727C196.317 160.371 195.395 160.188 194.464 160.188H166.314C165.382 160.188 164.46 160.371 163.599 160.726C162.739 161.082 161.957 161.603 161.298 162.261C160.639 162.919 160.117 163.699 159.76 164.559C159.403 165.418 159.219 166.339 159.219 167.27V192.61H201.556Z"
							fill="#4656A2"
						/>
						<path
							d="M156.702 192.607H204.081C204.595 192.607 205.011 193.024 205.011 193.537V197.256C205.011 197.769 204.595 198.185 204.081 198.185H156.702C156.188 198.185 155.771 197.769 155.771 197.256V193.537C155.771 193.024 156.188 192.607 156.702 192.607Z"
							fill="#39488D"
						/>
						<path
							d="M174.04 198.187H166.826V215.426C166.827 216.381 167.208 217.296 167.884 217.97C168.561 218.644 169.477 219.023 170.433 219.023C171.389 219.023 172.307 218.644 172.983 217.968C173.66 217.292 174.04 216.376 174.04 215.42V198.187Z"
							fill="#232851"
						/>
						<path
							d="M190.352 219.023C191.308 219.023 192.226 218.644 192.902 217.968C193.578 217.292 193.958 216.376 193.958 215.42V198.181H186.743V215.42C186.743 215.893 186.836 216.362 187.018 216.799C187.199 217.237 187.465 217.634 187.8 217.969C188.135 218.303 188.533 218.569 188.971 218.75C189.409 218.931 189.878 219.024 190.352 219.023Z"
							fill="#232851"
						/>
						<path
							d="M201.556 192.61V167.27C201.556 166.34 201.373 165.419 201.016 164.559C200.659 163.7 200.137 162.919 199.478 162.262C198.82 161.604 198.038 161.082 197.178 160.727C196.317 160.371 195.395 160.188 194.464 160.188H166.314C165.382 160.188 164.46 160.371 163.599 160.726C162.739 161.082 161.957 161.603 161.298 162.261C160.639 162.919 160.117 163.699 159.76 164.559C159.403 165.418 159.219 166.339 159.219 167.27C189.62 169.381 192.413 192.602 192.413 192.602L201.556 192.61Z"
							fill="#39488D"
						/>
						<path d="M201.556 192.61H159.219V190.567H201.556V192.61Z" fill="#2C3872" />
						<path
							d="M201.562 181.903V167.27C201.562 166.339 201.379 165.418 201.022 164.559C200.665 163.7 200.143 162.919 199.484 162.262C198.826 161.604 198.044 161.082 197.184 160.727C196.323 160.371 195.401 160.188 194.47 160.188H174.7C194.666 160.196 201.562 181.903 201.562 181.903Z"
							fill="#2C3872"
						/>
						<path d="M190.739 160.195H170.035V158.871H190.739V160.195Z" fill="#232851" />
						<path d="M174.041 200.711H166.826V198.188H174.041V200.711Z" fill="#15172D" />
						<path d="M193.958 200.711H186.743V198.188H193.958V200.711Z" fill="#15172D" />
						<path
							d="M190.75 160.195V150.366C190.75 149.646 190.608 148.933 190.333 148.267C190.057 147.602 189.652 146.998 189.143 146.489C188.633 145.98 188.028 145.576 187.362 145.3C186.696 145.025 185.982 144.883 185.261 144.884H175.532C174.738 144.883 173.953 145.055 173.233 145.388C172.512 145.72 171.872 146.205 171.358 146.809C186.524 144.95 188.841 160.193 188.841 160.193L190.75 160.195Z"
							fill="#232851"
						/>
						<path
							d="M374 407.819C374 406.975 373.664 406.166 373.067 405.569C372.47 404.972 371.66 404.637 370.815 404.637H202.039C197.144 404.637 192.448 402.695 188.987 399.236C185.525 395.778 183.58 391.088 183.579 386.197V302.569H177.208V386.197C177.208 392.775 179.824 399.084 184.48 403.735C189.136 408.387 195.451 411 202.035 411H370.815C371.66 411 372.47 410.665 373.067 410.068C373.664 409.472 374 408.662 374 407.819Z"
							fill="#2C447D"
						/>
						<path
							d="M190.739 309.731V322.411C190.739 323.131 190.597 323.844 190.321 324.51C190.045 325.175 189.641 325.779 189.131 326.288C188.622 326.798 188.016 327.201 187.35 327.477C186.684 327.752 185.971 327.894 185.25 327.893H175.52C174.727 327.894 173.942 327.722 173.221 327.39C172.501 327.057 171.861 326.572 171.347 325.968C170.498 324.978 170.033 323.717 170.035 322.413V309.733L190.739 309.731Z"
							fill="#2C3872"
						/>
						<path
							d="M201.561 280.168V305.5C201.561 306.431 201.377 307.352 201.021 308.212C200.664 309.071 200.142 309.852 199.483 310.51C198.825 311.168 198.043 311.689 197.182 312.045C196.322 312.401 195.4 312.584 194.468 312.584H166.318C164.437 312.584 162.634 311.838 161.304 310.509C159.975 309.181 159.228 307.379 159.228 305.5V280.168H201.561Z"
							fill="#4656A2"
						/>
						<path
							d="M156.702 274.594H204.081C204.595 274.594 205.011 275.01 205.011 275.523V279.242C205.011 279.755 204.595 280.171 204.081 280.171H156.702C156.188 280.171 155.771 279.755 155.771 279.242V275.523C155.771 275.01 156.188 274.594 156.702 274.594Z"
							fill="#39488D"
						/>
						<path
							d="M201.561 280.168V305.5C201.561 306.431 201.377 307.352 201.021 308.212C200.664 309.071 200.142 309.852 199.483 310.51C198.825 311.168 198.043 311.689 197.182 312.045C196.322 312.401 195.4 312.584 194.468 312.584H166.318C164.437 312.584 162.634 311.838 161.304 310.509C159.975 309.181 159.228 307.379 159.228 305.5C189.624 303.391 192.418 280.168 192.418 280.168H201.561Z"
							fill="#39488D"
						/>
						<path d="M201.556 282.21H159.219V280.167H201.556V282.21Z" fill="#2C3872" />
						<path
							d="M201.562 290.875V305.5C201.562 306.431 201.379 307.352 201.023 308.212C200.666 309.071 200.144 309.852 199.485 310.51C198.826 311.168 198.045 311.689 197.184 312.045C196.324 312.401 195.401 312.584 194.47 312.584H174.7C194.666 312.584 201.562 290.875 201.562 290.875Z"
							fill="#2C3872"
						/>
						<path d="M190.739 313.906H170.035V312.582H190.739V313.906Z" fill="#232851" />
						<path
							d="M190.75 312.584V322.411C190.75 323.131 190.608 323.844 190.333 324.51C190.057 325.175 189.652 325.779 189.143 326.288C188.633 326.798 188.028 327.201 187.362 327.477C186.696 327.752 185.982 327.894 185.261 327.893H175.532C174.738 327.894 173.953 327.722 173.233 327.39C172.512 327.057 171.872 326.572 171.358 325.968C186.524 327.827 188.841 312.586 188.841 312.586L190.75 312.584Z"
							fill="#232851"
						/>
						<path
							d="M124.861 252.473H111.752C111.273 252.473 110.814 252.663 110.476 253.001C110.137 253.339 109.947 253.798 109.947 254.276C109.947 254.754 110.137 255.213 110.476 255.551C110.814 255.889 111.273 256.079 111.752 256.079H124.849C125.328 256.079 125.787 255.889 126.125 255.551C126.464 255.213 126.654 254.754 126.654 254.276C126.654 253.798 126.464 253.339 126.125 253.001C125.787 252.663 125.328 252.473 124.849 252.473H124.861Z"
							fill="#4656A2"
						/>
						<path
							d="M141.499 269.096C141.021 269.096 140.562 269.286 140.223 269.624C139.885 269.962 139.695 270.421 139.695 270.899V283.996C139.695 284.474 139.885 284.932 140.223 285.27C140.562 285.608 141.021 285.798 141.499 285.798C141.978 285.798 142.437 285.608 142.775 285.27C143.113 284.932 143.304 284.474 143.304 283.996V270.899C143.304 270.421 143.113 269.962 142.775 269.624C142.437 269.286 141.978 269.096 141.499 269.096Z"
							fill="#4656A2"
						/>
						<path
							d="M129.47 264.49C128.991 264.491 128.532 264.681 128.193 265.019L119.189 274.015C119.021 274.182 118.888 274.381 118.798 274.599C118.707 274.818 118.66 275.053 118.66 275.289C118.66 275.526 118.706 275.761 118.797 275.979C118.888 276.198 119.02 276.397 119.188 276.564C119.355 276.732 119.554 276.865 119.773 276.955C119.992 277.046 120.227 277.093 120.464 277.093C120.701 277.093 120.936 277.046 121.154 276.956C121.373 276.865 121.572 276.733 121.74 276.565L130.746 267.568C130.998 267.316 131.169 266.994 131.238 266.645C131.308 266.295 131.272 265.933 131.135 265.604C130.999 265.275 130.768 264.993 130.471 264.795C130.175 264.597 129.826 264.491 129.47 264.49Z"
							fill="#4656A2"
						/>
						<path
							d="M235.925 211.915H249.035C249.513 211.915 249.972 211.725 250.31 211.387C250.649 211.049 250.839 210.59 250.839 210.112C250.839 209.634 250.649 209.176 250.31 208.837C249.972 208.499 249.513 208.309 249.035 208.309H235.925C235.446 208.309 234.987 208.499 234.649 208.837C234.311 209.176 234.121 209.634 234.121 210.112C234.121 210.59 234.311 211.049 234.649 211.387C234.987 211.725 235.446 211.915 235.925 211.915Z"
							fill="#4656A2"
						/>
						<path
							d="M219.29 195.295C219.769 195.295 220.228 195.104 220.566 194.766C220.904 194.428 221.094 193.969 221.094 193.491V180.406C221.079 179.938 220.882 179.494 220.545 179.168C220.208 178.843 219.758 178.661 219.289 178.661C218.82 178.661 218.37 178.843 218.033 179.168C217.696 179.494 217.499 179.938 217.484 180.406V193.491C217.484 193.969 217.674 194.428 218.013 194.767C218.351 195.105 218.811 195.295 219.29 195.295Z"
							fill="#4656A2"
						/>
						<path
							d="M231.314 199.898C231.551 199.898 231.786 199.852 232.005 199.761C232.224 199.671 232.423 199.538 232.591 199.371L241.595 190.373C241.883 190.028 242.032 189.587 242.012 189.138C241.991 188.688 241.803 188.262 241.485 187.944C241.166 187.626 240.74 187.439 240.29 187.418C239.841 187.398 239.399 187.546 239.053 187.835L230.047 196.83C229.795 197.082 229.623 197.403 229.553 197.753C229.483 198.103 229.519 198.466 229.655 198.795C229.792 199.125 230.024 199.406 230.321 199.604C230.618 199.803 230.967 199.908 231.324 199.908L231.314 199.898Z"
							fill="#4656A2"
						/>
					</svg>
				</Grid>
				<Grid xs={12} item className={classes.description}>
					<Typography className={classes.title}>عدم دسترسی به اینترنت</Typography>
					<Typography className={classes.subtitle}>
						از اتصال دستگاه خود به اینترنت مطمئن شوید و سپس
						<br />
						دوباره تلاش کنید
					</Typography>
				</Grid>
			</Grid>
		</KeepaLayout>
	);
};

export default Offline;
